module.exports = __webpack_public_path__ + "court.9c595c6982d077e9ce7f8c82faa5b4af.svg";